// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__WuvYM","inner":"Footer_inner__7nrXi","nav":"Footer_nav__brlzw","links":"Footer_links__DlsDM","josh":"Footer_josh__2P3MG"};